import { CKButton, CKModal } from 'clearkit';
import { FC, useState } from 'react';

import { User } from '~/generated/graphql';

type RemoveMembershipButtonProps = {
  isDisabled: boolean;
  isLoading: boolean;
  user: User;
  onChange: (id: string) => void;
  onLoadingChange: (isLoading: boolean) => void;
};

export const RemoveMembershipButton: FC<RemoveMembershipButtonProps> = ({
  isDisabled,
  isLoading,
  onChange,
  onLoadingChange,
  user,
}) => {
  const [showDialog, setShowDialog] = useState(false);

  const handleRemove = async () => {
    onLoadingChange(true);
    await onChange(user.id);
    onLoadingChange(false);
    setShowDialog(false);
  };

  return (
    <>
      <CKButton
        isDisabled={isDisabled}
        isLoading={isLoading}
        onClick={() => setShowDialog(true)}
        variant="simple"
        variantColor="red"
      >
        Remove user
      </CKButton>
      <CKModal
        aria-label="Remove Membership Modal"
        isVisible={showDialog}
        onToggle={() => setShowDialog(false)}
        size="sm"
      >
        <CKModal.Header>
          <CKModal.Heading>Remove user</CKModal.Heading>
        </CKModal.Header>
        <CKModal.Body className="px-10 py-6 ">
          This is a very destructive action.{' '}
          <strong>
            {user.name} ({user.email})
          </strong>{' '}
          will lose access to this team. Are you sure you want to do this?
        </CKModal.Body>
        <CKModal.Footer>
          <CKButton
            className="mr-2"
            isDisabled={isLoading}
            onClick={() => setShowDialog(false)}
          >
            Cancel
          </CKButton>
          <CKButton
            isLoading={isLoading}
            onClick={handleRemove}
            variantColor="red"
          >
            Remove user
          </CKButton>
        </CKModal.Footer>
      </CKModal>
    </>
  );
};
